module.exports = __webpack_public_path__ + "img/Au-Sable-River-Queen.72a4be31.jpg";